<!--
@component
@deprecated REPTILE-1303
-->
<script lang="ts">
    import { untrack } from 'svelte';
    import type { DresonRuleResolvedEvent, Page } from '@shared/types/Tilelist.ts';
    import type { TileListInitialSession } from '@tilelist/application/core/TileListInitialSession.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import { appendHeurekaFragment, clean, pagedUrl } from './Utils.browser.ts';

    const { initialSession }: { initialSession: TileListInitialSession } = $props();
    let { onex, browser: wiring } = $derived(injectWiring());

    function checkpointData(rule: string, page: Page, tsLink?: DresonRuleResolvedEvent['tsLink']) {
        return { rule, page: { ...page }, tsLink, historic: true };
    }

    function urlFor(event: DresonRuleResolvedEvent): string {
        const url = event.redirect ?? pagedUrl(clean(event.page), location.pathname, location.search);
        return event.redirect && onex.isToggleActive('DA_KEEP_HEUREKA_SHEET_FRAGMENT')
            ? appendHeurekaFragment(url)
            : url;
    }

    function handleResolved(event: DresonRuleResolvedEvent): void {
        if (!wiring) return;
        const url = urlFor(event);
        wiring.trackingService.trackUrl(event.redirect ?? url);
        if (!event.historic) {
            wiring.eventsOutgoing.pushHistoryCheckpoint({
                topic: 'ftfind.dresonRule.resolve',
                data: checkpointData(event.rule, event.page, event.tsLink),
                url,
            });
        }
    }

    function subscribe() {
        if (!wiring) return;
        wiring.eventsOutgoing.seedHistoryState({
            topic: 'ftfind.dresonRule.resolve',
            data: checkpointData(initialSession.page.context.rule, initialSession.page.page ?? {}, {}),
        });
        return wiring.eventsIncoming.onPageResolved(handleResolved);
    }

    $effect(() => {
        if (!wiring) return;
        return untrack(subscribe);
    });
</script>
